import { useTranslation } from 'react-i18next'

import type { BaseModalType } from '@app/context/ModalsContext'

import { Modal } from '@ui/components/Modal'

interface LayoutActionConfirmModalProps {
  actionEvent: 'save' | 'delete'
  onAccept: () => void | Promise<void>
  onCancel?: () => void
}

export const LayoutActionConfirmModal: BaseModalType<LayoutActionConfirmModalProps> = ({
  onAccept,
  onCancel,
  actionEvent,
  close,
}) => {
  const { t } = useTranslation()

  const handleAccept = async () => {
    await onAccept()
    close()
  }

  const handleCancel = () => {
    onCancel?.()
    close()
  }

  return (
    <Modal>
      <Modal.Header>{t('Dashboard.LayoutSettings')}</Modal.Header>

      <Modal.Body>
        <Modal.Body.Text>
          {actionEvent === 'save'
            ? t('Dashboard.Do you want to save custom layout?')
            : t('Dashboard.Are you sure you want to delete this layout?')}
        </Modal.Body.Text>
      </Modal.Body>

      <Modal.Footer>
        <Modal.Footer.Secondary onClick={handleCancel}>{t('No')}</Modal.Footer.Secondary>
        <Modal.Footer.Primary onClick={handleAccept}>{t('Yes')}</Modal.Footer.Primary>
      </Modal.Footer>
    </Modal>
  )
}
